import { dynamicImage } from "../../Service/DynamicImage";

export const CART = [
  {
    title: "Furniture Chair for Home",
    src: dynamicImage("other-images/cart-img.jpg"),
    price: "$500",
  },
  {
    title: "Furniture Chair for Home",
    src: dynamicImage("other-images/cart-img.jpg"),
    price: "$500",
  },
];
